import { Component, OnDestroy, OnInit, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { ActivatedRoute, Router } from "@angular/router";
import { MachineManagementService } from "@kpx/machine-management";
import { QuickscanService } from "@kpx/quickscan";
import { Subscription } from "rxjs";
import { ConfigurationService } from "../../../services/configuration.service";

@Component({
  selector: "app-header",
  imports: [MatIconModule, MatButtonModule],
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.less"],
})
export class HeaderComponent implements OnInit, OnDestroy {
  public fromPortal: boolean;
  public username: string | null;
  public routerSubscription: Subscription | null;
  public isManager: boolean;
  public machines = inject(MachineManagementService);

  public config: ConfigurationService;
  public route: ActivatedRoute;
  public quickscan = inject(QuickscanService);
  private router: Router;

  public constructor() {
    this.fromPortal = false;
    this.username = null;
    this.routerSubscription = null;
    this.isManager = false;

    this.config = inject(ConfigurationService);
    this.route = inject(ActivatedRoute);
    this.router = inject(Router);
  }

  public async ngOnInit(): Promise<void> {
    if (!JSON.stringify(localStorage.getItem("fromPortal"))) {
      this.route.queryParams.subscribe((value) => {
        if (value["reference"] === "portal") {
          localStorage.setItem("fromPortal", "true");
          this.fromPortal = true;
        }
      });
    } else {
      this.fromPortal = true;
    }
  }

  public ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  public returnPortal(): void {
    // window.location.href = `${this.quickscan.config.value?.PORTAL_URL}`;
    throw new Error("Method not implemented.");
  }

  public toQuickscans(): void {
    this.router.navigate([`/quickscans`]);
  }
}
